import {
  mockCmsFooter,
  mockCmsHeader,
  mockCmsPicture,
} from '@domgen/dgx-fe-cms';
import { CmsYourAppliancePage } from '../../../models/your-appliance/cms/cms-your-appliance-page.interface';

export const mockCmsYourAppliancePage: CmsYourAppliancePage = {
  title: '',
  header: mockCmsHeader,
  footer: mockCmsFooter,
  articleCategoriesBody:
    'Simply pick a category or search what you are looking for',
  articleCategoriesTitle: 'All the help you need to self-fix your appliance',
  articleCategoriesViewMoreLink: {
    label: 'View more',
    routerPath: '/articles',
  },
  repairRedirectTitle: 'Need a quick repair?',
  repairRedirectBody:
    'Whether or not you have a plan with us, you can book a repair now.',
  repairRedirectIconName: 'screwdriver-wrench',
  repairRedirectPrimaryLink: {
    label: 'Book with a plan',
    href: 'www.domesticandgeneral.com',
  },
  repairRedirectSecondaryLink: {
    label: 'Book without a plan',
    href: 'www.domesticandgeneral.com',
  },
  appliances: [
    {
      applianceCode: 'E4',
      applianceDescription: 'applianceDescription',
      picture: mockCmsPicture,
      popularVideosBlock: {
        '@path': '/test-path',
        '@name': 'Test Name',
        popularVideosBody:
          'Here is a selection of our most popular how-to videos.',
        popularVideosTitle: 'Prefer watching videos over reading?',
        popularVideos: [
          {
            popularVideo: {
              '@id': '1b1d7cb8-ac08-4f8a-9149-0e7028817550',
              '@path':
                '/gb/domestic-and-general/self-fix/videos/How-to-wash/Test-video0',
              articleTitle: 'Test Video',
              introText: 'Test',
            },
          },
          {
            popularVideo: {
              '@id': '5e7ebc42-dd6d-476b-8cef-269a28a854c4',
              '@path':
                '/gb/domestic-and-general/self-fix/videos/How-to-wash/How-to-fix-your-washing-machine',
              articleTitle: 'How to fix your washing machine',
              introText: 'Test',
            },
          },
          {
            popularVideo: {
              '@id': '321c1221-cea6-46d4-afe0-27ea3c5fabe7',
              '@path':
                '/gb/domestic-and-general/self-fix/videos/How-to-wash/Test-testing',
              articleTitle: 'Testing',
              introText: 'Test',
            },
          },
        ],
        viewAllVideosLink: {
          label: 'View all videos',
          routerPath: '/videos',
        },
      },
      popularArticlesBlock: {
        popularArticlesTitle: 'Popular articles',
        popularArticles: [
          {
            popularArticle: {
              '@path':
                '/gb/domestic-and-general/self-fix/articles/how-to-fix/Test-Article',
              articleTitle: 'Test Article',
            },
          },
          {
            popularArticle: {
              '@path':
                '/gb/domestic-and-general/self-fix/articles/how-to-fix/washing-machine',
              articleTitle: 'My washing machine is leaking',
            },
          },
          {
            popularArticle: {
              '@path':
                '/gb/domestic-and-general/self-fix/articles/how-to-fix/Test-Article',
              articleTitle: 'Test Article',
            },
          },
        ],
      },
      articleCategories: [
        {
          articleCategory: {
            '@path': '/gb/domestic-and-general/self-fix/articles/how-to-fix',
            name: 'How-to-fix',
          },
        },
        {
          articleCategory: {
            '@path': '/gb/domestic-and-general/self-fix/articles/repairing',
            name: 'Repairing',
          },
        },
        {
          articleCategory: {
            '@path':
              '/gb/domestic-and-general/self-fix/videos/how-to-wash/washing-machine',
            name: 'How-to-wash',
          },
        },
      ],
    },
  ],
};
